<template>
  <ThemeProvider :id="ID_LAYOUT_DEFAULT" :color="themeColor" class="outer">
    <sh-header
      v-if="!isWebview"
      @skipToMainContent="skipToMainContent"
      @skipToFooterContent="skipToFooterContent"
    />
    <!-- TODO: This div should be a main but in order to do that we need to remove all the other mains -->
    <div ref="mainContent" class="main-content" tabindex="-1">
      <slot>
        <nuxt />
      </slot>
    </div>
    <sh-footer ref="footerContent" class="footer-content" tabindex="-1" />
    <critical-error-modal />
    <CookieConsent v-if="!isWebview" />
  </ThemeProvider>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { ThemeProvider } from '@sohohouse/design-system'

import { ID_LAYOUT_DEFAULT } from '~/constants/integration'
import CriticalErrorModal from '~/components/critical-error-modal'
import ShHeader from '~/components/sh-header'
import ShFooter from '~/components/sh-footer'
import isEmptyObject from '~/helpers/is-empty-object'
import ThemeMixin from '~/mixins/theme'
import Theme from '../constants/theme'

const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  authenticated: true,

  middleware: [
    'fetchUser',
    'isAuthorized',
    'canAccessMemberApp',
    'hasBeenInducted',
    'initializer'
  ],

  mixins: [ThemeMixin],

  components: {
    CriticalErrorModal,
    ShHeader,
    ShFooter,
    ThemeProvider
  },

  head () {
    this.$nuxtI18nSeo()
    return {
      bodyAttrs: {
        'data-app-id': this.$env.APP_VERSION,
        class: this.bodyClass
      }
    }
  },

  data () {
    return {
      ID_LAYOUT_DEFAULT
    }
  },

  computed: {
    ...mapEnvGetters(['isWebview', 'themeColor']),

    hasProfile () {
      return this.profile && !isEmptyObject(this.profile)
    },

    // TODO components should not be using this to style it should be removed
    bodyClass () {
      return `theme-${this.themeColor === Theme.Dark ? 'black' : 'white'}`
    }
  },

  methods: {
    skipToMainContent () {
      this.$refs.mainContent.focus()
    },

    skipToFooterContent () {
      this.$refs.footerContent.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
  body {
    &.isWebview {
      background: $color-black;
    }
  }

  .main-content, .footer-content {
    &:focus {
      outline: none;
    }
  }
</style>
